<template>
  <div>
    <v-navigation-drawer
      v-model="localDrawer"
      temporary
      app
      class="navigation-drawer"
      color="surface"
      width="280"
    >
<!--      <v-list-item-->
<!--        class="nav-item"-->
<!--        prepend-icon="mdi-account"-->
<!--        :title="`${user.full_name}`"-->
<!--      ></v-list-item>-->
      <v-divider></v-divider>

      <!-- Search Section -->
      <div class="search-section">
        <v-text-field
          v-model="searchQuery"
          prepend-inner-icon="mdi-magnify"
          placeholder="Search screens"
          variant="outlined"
          density="compact"
          hide-details
          class="search-field"
          clearable
        ></v-text-field>
      </div>

      <v-list class="nav-list" nav>
        <div class="section-group">
          <v-list-subheader class="section-header">Money Requests</v-list-subheader>
          <v-list-item
            v-if="hasPermission('canCreateExpenseRequest')"
            v-show="matchesSearch('New Expense Request')"
            prepend-icon="mdi-receipt"
            title="New Expense Request"
            value="new-expense-request"
            to="/expenses/new"
            class="nav-item"
          ></v-list-item>
          <v-list-item
            v-if="hasPermission('canCreateExpenseRequest')"
            v-show="matchesSearch('Supplier Payments')"
            prepend-icon="mdi-storefront"
            title="Supplier Payments"
            value="supplier-payments"
            to="/expenses/supplier-payment"
            class="nav-item"
          ></v-list-item>
          <v-list-item
            v-if="hasPermission('canCreateExpenseRequest')"
            v-show="matchesSearch('GRV Payments')"
            prepend-icon="mdi-receipt-text"
            title="GRV Payments"
            value="grv-payments"
            to="/expenses/grv-payments"
            class="nav-item"
          ></v-list-item>
          <v-list-item
            v-if="hasPermission('canCreateExpenseRequest')"
            v-show="matchesSearch('My Requests')"
            prepend-icon="mdi-format-list-bulleted"
            title="My Requests"
            value="my-requests"
            to="/requests"
            class="nav-item"
          ></v-list-item>
        </div>

        <div class="section-group">
          <v-list-subheader class="section-header" v-if="hasPermission('canCreateExpenseRequest')">Receive Payment</v-list-subheader>
          <v-list-item
            v-if="hasPermission('canCreateExpenseRequest')"
            v-show="matchesSearch('Receive Payment')"
            prepend-icon="mdi-cash-multiple"
            title="Receive Payment"
            value="kazang-withdraw"
            to="/payments/create-link"
            class="nav-item"
          ></v-list-item>
          <v-list-item
            v-if="hasPermission('canCreateExpenseRequest')"
            v-show="matchesSearch('Payment Link')"
            prepend-icon="mdi-link-variant"
            title="Payment Link"
            value="payment-link-creator"
            to="/payments/payment-link"
            class="nav-item"
          ></v-list-item>
          <v-list-item
            v-if="hasPermission('canCreateExpenseRequest')"
            v-show="matchesSearch('Deposit')"
            prepend-icon="mdi-cash-plus"
            title="Deposit"
            value="kazang-deposit"
            to="/payments/deposit"
            class="nav-item"
          ></v-list-item>
        </div>

        <div class="section-group">
          <v-list-subheader class="section-header" v-if="hasPermission('canApproveExpenseRequest')">Expense Requests</v-list-subheader>
          <v-list-item
            v-if="hasPermission('canApproveExpenseRequest')"
            v-show="matchesSearch('Incoming Expense Requests')"
            prepend-icon="mdi-cash-check"
            title="Incoming Expense Requests"
            value="incoming-expense-requests"
            to="/expense-requests/pending"
            class="nav-item"
          ></v-list-item>
          <v-list-item
            v-if="hasPermission('canApproveExpenseRequest')"
            v-show="matchesSearch('Pending Deposits')"
            prepend-icon="mdi-cash-clock"
            title="Pending Deposits"
            value="pending-deposits"
            to="/expense-requests/pending-otp"
            class="nav-item"
          ></v-list-item>
        </div>

        <div class="section-group">
          <v-list-subheader class="section-header" v-if="hasPermission('canViewReports')">Reports</v-list-subheader>
          <v-list-item
            v-if="hasPermission('canViewReports')"
            v-show="matchesSearch('Reports Dashboard')"
            prepend-icon="mdi-chart-bar"
            title="Reports Dashboard"
            value="reports-dashboard"
            to="/reports/dashboard"
            class="nav-item"
          ></v-list-item>
        </div>

        <div class="section-group">
          <v-list-subheader class="section-header" v-if="hasPermission('canManageUsers') || hasPermission('canManageRoles')">Administration</v-list-subheader>
          <v-list-item
            v-if="hasPermission('canManageUsers') || hasPermission('canManageRoles')"
            v-show="matchesSearch('Admin Panel')"
            prepend-icon="mdi-shield-account"
            title="Admin Panel"
            value="admin-panel"
            to="/admin"
            class="nav-item"
          ></v-list-item>
        </div>

      <v-divider class="mt-2"></v-divider>
      <div class="section-group">
        <v-list-subheader class="section-header">Account</v-list-subheader>
        <v-list-item
          prepend-icon="mdi-logout"
          title="Logout"
          value="logout"
          class="nav-item"
          @click="handleLogout"
        ></v-list-item>
      </div>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "NavigationDrawer",
  props: {
    drawerOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localDrawer: this.drawerOpen,
      searchQuery: ''
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.getUserRole || {};
    },
    user() {
      return this.$store.getters.CurrentUserInfo;
    },
  },
  methods: {
    hasPermission(permission) {
      const permissions = this.userPermissions;

      // Check for camelCase version (e.g., canApproveExpenseRequest)
      if (permissions && permissions[permission] === true) {
        return true;
      }

      // Convert camelCase to snake_case (e.g., canApproveExpenseRequest -> can_approve_expense_request)
      const snakeCasePermission = permission.replace(/([A-Z])/g, "_$1").toLowerCase();

      // Check for snake_case version (e.g., can_approve_expense_request)
      if (permissions && permissions[snakeCasePermission] === true) {
        return true;
      }

      return false;
    },
    matchesSearch(title) {
      const q = (this.searchQuery || '').trim().toLowerCase();
      if (!q) return true;
      return String(title || '').toLowerCase().includes(q);
    },
    async handleLogout() {
      window.$analytics?.trackAuth('logout');

      try {
        await this.$store.dispatch('logout');
        await this.$router.push({ name: 'LoginForm' });
      } catch (e) {
        console.error('Logout failed', e);
        this.$router.push({ name: 'LoginForm' });
      }
    }
  },
  watch: {
    drawerOpen(newVal) {
      this.localDrawer = newVal;
    }
  },
  mounted() {
    console.log('User Permissions:', this.userPermissions);

    // Log examples of permission checks for debugging
    if (this.userPermissions) {
      console.log('Permission check examples:');
      console.log('canApproveExpenseRequest:', this.hasPermission('canApproveExpenseRequest'));
      console.log('can_approve_expense_request:', this.hasPermission('canApproveExpenseRequest'));
      console.log('canManageRoles:', this.hasPermission('canManageRoles'));
      console.log('can_manage_roles:', this.hasPermission('canManageRoles'));
    }
  }
}
</script>

<style scoped lang="scss">
.navigation-drawer {
  z-index: 2000 !important;
  padding-bottom: 20px !important;
  padding-bottom: var(--app-safe-area-bottom, 20px) !important;

  .search-section {
    padding: 16px 16px 8px 16px;
    border-bottom: 1px solid rgb(var(--v-theme-border-color));
    margin-bottom: 8px;
  }

  .search-field {
    :deep(.v-field) {
      background-color: rgb(var(--v-theme-background)) !important;
      border-radius: 8px;
      border: 1px solid rgb(var(--v-theme-border-color));

      &:hover {
        border-color: rgba(var(--v-theme-on-surface), 0.5);
      }

      &.v-field--focused {
        border-color: rgb(var(--v-theme-primary));
      }
    }

    :deep(.v-field__input) {
      padding: 8px 12px;
      font-size: 14px;
      min-height: 36px;
    }

    :deep(.v-field__prepend-inner) {
      padding-top: 0;
      align-items: center;

      .v-icon {
        color: rgb(var(--v-theme-text-secondary));
        font-size: 18px;
      }
    }
  }

  .nav-list {
    padding: 0;
  }

  .section-group {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 16px;
    }
  }

  .section-header {
    font-size: 12px;
    font-weight: 600;
    color: rgb(var(--v-theme-text-secondary));
    text-transform: none;
    letter-spacing: 0.5px;
    padding: 8px 16px 8px 16px;
    margin-bottom: 4px;
    height: auto;
    min-height: auto;
  }

  .nav-item {
    margin: 2px 12px;
    border-radius: 8px;
    transition: all 0.2s ease;

    :deep(.v-list-item__content) {
      padding: 8px 0;
    }

    :deep(.v-list-item__prepend) {
      .v-icon {
        color: rgb(var(--v-theme-text-secondary));
        font-size: 20px;
        margin-right: 12px;
      }
    }

    :deep(.v-list-item-title) {
      font-size: 14px;
      font-weight: 500;
      color: rgb(var(--v-theme-text-primary));
    }

    &:hover {
      background-color: rgba(var(--v-theme-on-surface), 0.05) !important;

      :deep(.v-list-item-title) {
        color: rgb(var(--v-theme-primary));
      }

      :deep(.v-list-item__prepend .v-icon) {
        color: rgb(var(--v-theme-primary));
      }
    }

    &.v-list-item--active {
      background-color: rgba(var(--v-theme-primary), 0.1) !important;

      :deep(.v-list-item-title) {
        color: rgb(var(--v-theme-primary));
        font-weight: 600;
      }

      :deep(.v-list-item__prepend .v-icon) {
        color: rgb(var(--v-theme-primary));
      }
    }
  }

  .new-badge {
    font-size: 10px;
    height: 18px;
    font-weight: 600;
    background: rgb(var(--v-theme-primary)) !important;
    color: rgb(var(--v-theme-on-primary)) !important;
  }
}

/* Deep selectors to ensure Vuetify internal elements respect styling */
:deep(.v-navigation-drawer__content) {
  z-index: 2001 !important;
  background-color: rgb(var(--v-theme-surface));
}

:deep(.v-overlay__scrim) {
  z-index: 1999 !important;
}

/* Remove default Vuetify list item padding and margins */
:deep(.v-list-item) {
  padding-left: 16px !important;
  padding-right: 16px !important;
  min-height: 40px;
}

:deep(.v-list-item__prepend) {
  width: 32px;
}

:deep(.v-list-subheader) {
  text-transform: none;
}
</style>
